import { db } from "../../../config/firebaseconfig";

/**
 * Creates the username data that will be presented as a csv download 
 * after bulk data upload. Also backs up data to collection.
 * @param {object} backup the backup data stored while processing CSV
 * @param {string} recordId id of the school
 * @param {string} assessmentId id of the assessment set
 * @param {number} year school year in format 2018 for 2018-19
 * @returns {object} {students, teachers, } object containing arrays with data to be parsed
 */
export default function createUsernameCSVs (backup, recordId, assessmentId, year) {
  function createUsernameCSV (records) {
    let data = []
    records.forEach(record => {
      if (!record) return
      const {
        username,
        fullName,
        email,
        password,
      } = record
      data.push({ username, email, fullName, password, }) 
    })
    // return Papa.unparse(data)
    return data
  }

  const students = createUsernameCSV(backup.createdStudents)
  const teachers = createUsernameCSV(backup.createdTeachers)
  let promises = []

  if (students.length > 0) {
    const storeStudentsCSV = db.collection('usernameCSVs').add({
      data: students, 
      recordId, 
      assessmentId, 
      year,
      dateUploaded: Date.now(),
      dataType: 'students',
    })
    promises.push(storeStudentsCSV)
  }

  if (teachers.length > 0) {
    const storeTeachersCSV = db.collection('usernameCSVs').add({
      data: teachers, 
      recordId, 
      assessmentId, 
      year,
      dateUploaded: Date.now(),
      dataType: 'teachers'
    })
    promises.push(storeTeachersCSV)
  }

  return Promise.all(promises)
    .then(() => {
      return {students, teachers}
    })
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/uploadCSV/createUsernameCSVs.js